import { render, staticRenderFns } from "./ArtistVenueCard.vue?vue&type=template&id=75163d88&"
import script from "./ArtistVenueCard.vue?vue&type=script&lang=js&"
export * from "./ArtistVenueCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtistVenueCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports